import {Component, computed, input} from '@angular/core';
import {getHandicapRow, getHolesRow, getParsRow} from "../../rows/course-rows";
import {RowComponent} from "../../row/row.component";
import {NgForOf} from "@angular/common";
import {Card} from "../../model/scorecard-model";
import {CourseCard} from "../../model/course-card-model";

@Component({
    selector: 'course-card',
    templateUrl: './course-card.component.html',
    imports: [
        RowComponent,
        NgForOf
    ],
    styleUrls: ['./course-card.component.css']
})
export class CourseCardComponent {
    card = input.required<Card>();

    rows = computed(() => {
        const courseCard = this.card() as CourseCard
        return [
            getHolesRow(courseCard),
            getParsRow(courseCard),
            getHandicapRow(courseCard)
        ]
    });
}
